import React , { Component } from 'react';
import Menu from './menu';
import Footer from './footer';
import './App.css';
import './about';
import {
    Collapse, CardBody, Card, Container, Row, Col, Breadcrumb, BreadcrumbItem,Button,
    CardTitle, CardImg, CardText, CardSubtitle, CardLink,Label,Modal, ModalHeader, ModalBody, ModalFooter
  } from 'reactstrap';
import building from './img/building.png';import android from './img/android.png';import win from './img/win.png';
import php from './img/php.png';import web from './img/web.png';import desaign from './img/desaign.png';
import js from './img/js.png';import prd_web from './img/prd_web.png';import prd_win from './img/prd_win.png';
import prd_mob from './img/prd_mob.jpg';import mploye from './img/mploye.jpg';import mploye2 from './img/mploye2.jpg';
import mploye3 from './img/mploye3.jpg';import client1 from './img/client1.png';import client2 from './img/client2.png';
import client3 from './img/client3.png';import client4 from './img/client4.png';import client5 from './img/client5.png';
import client6 from './img/client6.png';import news1 from './img/news1.jpg';import news2 from './img/news2.jpg';
import news3 from './img/news3.jpg';import news4 from './img/news4.jpg';

export default class App extends Component {
    render() {
     return (
        <div>
            <Menu />
            <Jumbotron1/>
            <Breadcrumbs/>           
            <About/>
            <Service/>
            <Products/>
            <Contact/>
            <Team/>
            <Blog/>
            <Partner/>
            <Footer/>
        </div>
    );
  }
}   
class Breadcrumbs extends Component {
      render(){
        return(
        <div>
          <Breadcrumb tag="nav">
            <BreadcrumbItem active tag="span" tag="a" href="/">Home</BreadcrumbItem>
            <BreadcrumbItem tag="a" href="/about">About</BreadcrumbItem>
            <BreadcrumbItem tag="a" href="/products">Products</BreadcrumbItem>
            <BreadcrumbItem tag="a" href="/contact">Contact</BreadcrumbItem>
            <BreadcrumbItem tag="a" href="/service">Service</BreadcrumbItem>
            <BreadcrumbItem tag="a" href="/berita">Berita</BreadcrumbItem>
         </Breadcrumb>
        </div>
        );
      } 
}
class Jumbotron1 extends Component{
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }
  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }
    render(){
        return(
            <div>
                <div className="Jumbotron text-center">
                    <h1 fluid>AGUSTIAN TECHNO</h1>
                    <h3>SOFTWARE PRODUCTS SERVICE AND DEVELOPMENT</h3>
                    <Button color="danger" onClick={this.toggle}>KLIK ME !!!</Button><br/>
                    <Modal isOpen={this.state.modal} toggle={this.toggle} className={this.props.className}>
                      <ModalHeader toggle={this.toggle}>Tentang Web Ini</ModalHeader>
                      <ModalBody>
                        Website ini hanyalah bagian dari latihan saya(author), bukan lah website perusahaan yang sesungguhnya.
                        Maka dari itu, apabila web ini membuat anda/seseorang merasa tersinggung saya memohon maaf yang sebesar-besarnya.
                        Karena, saya bertujuan semata-mata untuk menggali skill dan kemampuan saya dibidang web programming.
                        Web ini memiliki hak cipta,<br/><br/>25 sept,tertanda<br/>Developer
                      </ModalBody>
                      <ModalFooter>
                        <Button color="primary" onClick={this.toggle}>Saya Mengerti</Button>
                      </ModalFooter>
                    </Modal>
                    
                </div>                
            </div>
        );
    }
}
class About extends Component {
    render() {
     return (
      <div>
        <section id="about" className="noimage"><br/>
          <Container>
            <Row className="text-center">
              <Col sm="12">
                <h2>About Us</h2><hr/>
              </Col>
            </Row>
            <Row className="textabout text-justify">
              <Col sm="8" >Agustian techno adalah perusahaan (masih perencanaan) di bidang Software 
              Development Services dan Software Product. Kami memiliki beragam kemampuan untuk 
              Software Development. Namun kami akan berfokus pada bidang Mobile, Web, dan desktop. 
              Seluruh layanan kami tersebut didukung oleh sistem manajemen sumber daya manusia 
              terbaik di kelasnya dan model engagement yang terintegrasi.</Col>
              <Col sm="4"><img src={building} /> </Col>
              <Col sm="12" className="text-center">
                <br/><Button href="./about" outline color="primary" center>next read &#10095;</Button>
              </Col>
            </Row>
          </Container><br/>
        </section>
      </div>
     );
     }
}
class Service extends Component {
  constructor(props) {
    super(props);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.toggle4 = this.toggle4.bind(this);
    this.toggle5 = this.toggle5.bind(this);
    this.toggle6 = this.toggle6.bind(this);
    this.state = { collapse: false };
  }
  toggle1() {this.setState({ collapse1: !this.state.collapse1 });}
  toggle2() {this.setState({ collapse2: !this.state.collapse2 });}
  toggle3() {this.setState({ collapse3: !this.state.collapse3 });}
  toggle4() {this.setState({ collapse4: !this.state.collapse4 });}
  toggle5() {this.setState({ collapse5: !this.state.collapse5 });}
  toggle6() {this.setState({ collapse6: !this.state.collapse6 });}
    render() {
        return (
            <div>
              <section id="service">
                <Container className="text-center">
                   <Row>
                       <Col sm="12" className="inverse">
                         <br/><h2>Service</h2> <hr height="1px"/><br/><br/>
                       </Col>
                   </Row>
                  <Row>
                      <Col xs="4">                     
                          <Button outline color="primary" onClick={this.toggle1}><img className="logo" src={win}/></Button>                        
                          <Collapse isOpen={this.state.collapse1}>
                          <br/><Card>                                  
                                    <CardTitle><br/>Windows aplication</CardTitle>                                
                                </Card>
                              </Collapse>
                      </Col>
                      <Col xs="4">
                          <Button outline color="primary" onClick={this.toggle2}><img className="logo" src={android}/></Button>                        
                          <Collapse isOpen={this.state.collapse2}>
                                <br/><Card>                                  
                                    <CardTitle><br/>Mobile aplication</CardTitle>                                                                  
                                </Card>
                              </Collapse>                          
                      </Col>
                      <Col xs="4">
                          <Button outline color="primary" onClick={this.toggle3}><img className="logo" src={web}/></Button>                        
                          <Collapse isOpen={this.state.collapse3}>
                                <br/><Card>                                  
                                    <CardTitle><br/>Web Development</CardTitle>                                 
                                </Card>
                              </Collapse>                          
                      </Col>
                    </Row><Row>
                      <Col xs="4"><br/><br/>
                          <Button outline color="primary" onClick={this.toggle4}><img className="logo" src={php}/></Button>                        
                          <Collapse isOpen={this.state.collapse4}>
                                <br/><Card>                                  
                                    <CardTitle><br/>PHP</CardTitle>                         
                                </Card>
                              </Collapse>                          
                      </Col>
                      <Col xs="4"><br/><br/>
                          <Button outline color="primary" onClick={this.toggle5}><img className="logo" src={js}/></Button>                        
                          <Collapse isOpen={this.state.collapse5}>
                                <br/><Card>                                  
                                    <CardTitle><br/>Javascript</CardTitle>                                
                                </Card>
                              </Collapse>                          
                      </Col>
                      <Col xs="4"><br/><br/>
                          <Button outline color="primary" onClick={this.toggle6}><img className="logo" src={desaign}/></Button>                    
                          <Collapse isOpen={this.state.collapse6}>
                            <br/><Card>                              
                                <CardTitle><br/>Desaign UI/UX</CardTitle>                          
                            </Card>
                          </Collapse>                    
                      </Col>
                  </Row>
                  <Row>
                    <Col sm="12" className="text-center"><br/>
                      <Button href="/service" color="primary" style={{fontFamily:"rubik regular"}} >MORE &#10095;</Button> 
                    </Col>
                  </Row>
                </Container><br/>
              </section>
            </div>
    );
  }
}
class Products extends Component {
    render() {
        return (
        <div>
          <section id="products" className="noimage">
                <Container>
                   <Row className="text-center">
                       <Col sm="12">
                         <h2>Products</h2> <hr/>    
                       </Col>
                   </Row>
                  <Row>
                      <Col sm="4">                     
                        <Card className="procard">                          
                          <CardBody><CardImg src={prd_win} alt="Card image cap" />
                            <CardTitle>Accmis</CardTitle>
                            <CardSubtitle>Windows Aplication</CardSubtitle>
                            <CardText className="text-justify" >kepanjangan dari Accounting Management system, 
                                      ditujukan kepada perusahaan pada bidang accounting.
                                      dengan adannya aplikasi ini diharapkan pengguna lebih
                                      efesien dan cepat dalam penghitungan.
                            </CardText>
                            <Button>lihat lebih &#10095;</Button>
                          </CardBody>                            
                        </Card>
                      </Col>
                      <Col sm="4">
                        <Card className="procard">                          
                          <CardBody><CardImg src={prd_mob} alt="Card image cap" />
                            <CardTitle>Emtor</CardTitle>
                            <CardSubtitle>Mobile Aplication</CardSubtitle>
                            <CardText className="text-justify">Emtor adalah singkatan dari Employer Controler,
                                      ditujukan untuk memonitoring jadwal kerja, absen, 
                                      kemajuan teknik, dan kenyamanan karyawan pada perusahaan 
                                      tersebut.
                            </CardText>
                            <Button>lihat lebih &#10095;</Button>
                          </CardBody>                          
                        </Card>
                  </Col>
                      <Col sm="4">
                        <Card className="procard">                          
                          <CardBody><CardImg src={prd_web} alt="Card image cap" />
                            <CardTitle>Website</CardTitle>
                            <CardSubtitle>Web Aplication</CardSubtitle>
                            <CardText className="text-justify">Web ini berpengaruh pada pendapatan lokal dan eksternal,
                                      didalamnya kaya akan fitur managing sistem mulai dari
                                      skala kecil hingga skala besar. database yang diyakini
                                      memiliki keamanan tingkat profesional.
                            </CardText>
                            <Button>lihat lebih &#10095;</Button>
                          </CardBody>                          
                        </Card>
                      </Col>
                  </Row>
                  <Row>
                    <Col sm="12" className="text-center"><br/><br/>
                      <Button href="/products" color="primary" style={{fontFamily:"rubik regular"}} >MORE &#10095;</Button> 
                    </Col>
                  </Row>
                </Container><br/>
            </section>
       </div>
     );
  }
}
class Contact extends Component {
    render() {
        return (
            <div>
              <section id="contact">
                  <Row>
                      <Col sm="10">
                        We Create Integrated, innovative and creative IT solutions. what are you waiting...
                      </Col>
                      <Col sm="2">
                      <Button outline color="secondary" href="/contact"> Contact Us!</Button>
                      </Col>
                  </Row>
              </section>
            </div>
    );
  }
}
class Team extends Component {
  constructor(props) {
    super(props);
    this.toggle1 = this.toggle1.bind(this);
    this.toggle2 = this.toggle2.bind(this);
    this.toggle3 = this.toggle3.bind(this);
    this.state = { collapse: false };
  }
  toggle1() {this.setState({ collapse1: !this.state.collapse1 });}
  toggle2() {this.setState({ collapse2: !this.state.collapse2 });}
  toggle3() {this.setState({ collapse3: !this.state.collapse3 });}

  render() {
      return (
          <div>
            <section id="team"><br/>
              <Container>
                 <Row className="text-center">
                     <Col sm="12">
                       <h2>Our Team</h2> <hr className="team"/>    
                     </Col>
                 </Row>
                <Row className="text-center">
                    <Col xs="4">
                      <Label onClick={this.toggle1} ><img src={mploye2} className="pgw"/><br/>MASK ARYAWAN</Label><br/>
                      <Collapse isOpen={this.state.collapse1}>
                        <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                        bawahnya juga bla bla bla tentang info yang menarik, biar
                        ga jenuh pembacanya.
                      </Collapse>
                    </Col>
                    <Col xs="4">
                      <Label onClick={this.toggle2} ><img src={mploye} className="pgw"/><br/>NAITSUGA</Label><br/>
                      <Collapse isOpen={this.state.collapse2}>
                        <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                        bawahnya juga bla bla bla tentang info yang menarik, biar
                        ga jenuh pembacanya.
                      </Collapse>
                    </Col>
                    <Col xs="4">
                      <Label onClick={this.toggle3} ><img src={mploye3} className="pgw"/><br/>VEGA WAY</Label><br/>
                      <Collapse isOpen={this.state.collapse3}>
                        <br/>biodatanya dia, ada info kontak, hobi, dan data lainnnya.
                        bawahnya juga bla bla bla tentang info yang menarik, biar
                        ga jenuh pembacanya.
                      </Collapse>
                    </Col>
                </Row><br/>
              </Container>
            </section>
          </div>
  );
}
}
class Blog extends Component {
  render() {
      return (
          <div>
            <section id="berita" className="noimage"><br/><br/>
              <Container>
                 <Row className="text-center">
                     <Col sm="12">
                       <h2>Terbaru Dari Kami</h2> <hr/>                       
                     </Col>
                 </Row>
                <Row>
                    <Col sm="2">
                      <CardLink href="#21"><img src={news1} className="berita img-thumbnail"/></CardLink>
                    </Col>
                    <Col sm="4" className="newslink">
                        <CardLink href="#21">kenaikan income sebesar 15%!!</CardLink>                                                                                                                
                            <CardText className="text-justify" >
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium illo necessitatibus, laborum rerum nihil, vel accusamus!
                            </CardText>                             
                          <hr className="newslist"/>
                    </Col>                              
                    <Col sm="2">
                      <CardLink href="#21"><img src={news2} className="berita img-thumbnail"/></CardLink>
                    </Col>
                    <Col sm="4" className="newslink" >
                        <CardLink href="#21">Banyaknya Request Project WEB</CardLink>                                                                                                                    
                            <CardText className="text-justify">
                            Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium illo necessitatibus, laborum rerum nihil, vel accusamus!
                            </CardText>                             
                          <hr className="newslist"/>
                    </Col>                           
                    <Col sm="2">
                     <CardLink href="#21"><img src={news3} className="berita img-thumbnail"/></CardLink>
                    </Col>
                    <Col sm="4" className="newslink" >
                       <CardLink href="#21">Ini dia daftar pekerjaan yang...</CardLink>                                                                                                                     
                            <CardText className="text-justify">
                              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium illo necessitatibus, laborum rerum nihil, vel accusamus!
                            </CardText>                             
                          <hr className="newslist"/>
                    </Col>                             
                    <Col sm="2">
                      <CardLink href="#21"><img src={news4} className="berita img-thumbnail"/></CardLink>
                    </Col>
                    <Col sm="4" className="newslink" >
                        <CardLink href="#21">Tertarik bekerja dengan kami ?</CardLink>                                                                                                                    
                            <CardText className="text-justify">
                              Lorem ipsum dolor sit amet, consectetur adipisicing elit. Laudantium illo necessitatibus, laborum rerum nihil, vel accusamus!
                            </CardText>                             
                          <hr className="newslist"/>
                    </Col> 
                  </Row>
                  <Row>
                    <Col sm="12" className="text-center">
                      Temukan Berita Menarik Lainnnya! <br/>
                      <Button href="/blog" color="primary" style={{fontFamily:"rubik regular"}} >MORE &#10095;</Button> 
                    </Col>
                  </Row><br/>                   
              </Container>
            </section>
          </div>
  );
 }
}
class Partner extends Component {
  render() {    
      return (
          <div>
            <section id="partner">
              <Container>
                 <Row className="text-center">
                    <Col sm="12"><br/><h2>Our Partner</h2> <hr/> </Col>
                 </Row><Row>
                    <Col sm="2">                        
                      <img src={client1}/>
                    </Col><Col sm="2">
                      <img src={client2}/>
                    </Col><Col sm="2">
                      <img src={client3}/>
                    </Col><Col sm="2">
                      <img src={client4}/>
                    </Col><Col sm="2">
                      <img src={client5}/>
                    </Col><Col sm="2">
                      <img src={client6}/>
                    </Col>
                </Row><br/><br/><br/>
              </Container>
            </section>
          </div>
  );
 }
}


// WEBPACK FOOTER //
// ./src/App.js